import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import PopularTreatments from '../components/PopularTreatments';
import PricingComparison from '../components/PricingComparison';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import ReadyToSave from '../components/ReadyToSave';
import WhyPatientsLove from '../components/WhyPatientsLove';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <HowItWorks />
      <Stats />
      <WhyPatientsLove />
      <PopularTreatments />
      <Testimonials />
      <PricingComparison />
      <FAQ />
      <ReadyToSave />
    </div>
  );
};

export default Home;
